/* eslint-disable import/prefer-default-export */
import {
	REQUEST_ACTIVE_MODEL,
	RECEIVE_ACTIVE_MODEL,
	ACTIVE_MODEL_ERROR,
	RECEIVE_UPDATE_MODEL,
	REQUEST_UPDATE_MODEL,
	UPDATE_MODEL_ERROR,
	RECEIVE_ADD_MODEL,
	REQUEST_ADD_MODEL,
	ADD_MODEL_ERROR,
	REQUEST_MASTERCLASS_LIST,
	RECEIVE_MASTERCLASS_LIST,
	MASTERCLASS_LIST_ERROR,
	RECEIVE_MODEL_DATA_UPDATE,
	REQUEST_MODEL_INFO,
	RECEIVE_MODEL_INFO,
	MODEL_INFO_ERROR,
	REQUEST_QUALITY_GATES,
	RECEIVE_QUALITY_GATES,
	QUALITY_GATES_ERROR,
} from '../actions/activeModelActions';

import { RECEIVE_ADD_VIEW } from '../actions/viewActionsRedux';

import { RECEIVE_DELETE_MODEL } from '../actions/modelListActions';

import { RECEIVE_LOGOUT_USER } from '../actions/activeUserActions';

import { UPDATE_RECO_MODE } from '../actions/projectActionsRedux';

const initialActiveModelState = {
	isFetching: false,
	model: {
		displayTitle: {
			de: '',
			en: '',
		},
		revision: '',
		slug: '',
		homeView: '',
		_id: '',
		views: [],
		masterClasses: [],
		info: [],
		projectOverview: [],
		qualityGates: [],
		recoMode: false,
	},
	error: null,
};

export const activeModelReducer = (state = initialActiveModelState, action) => {
	switch (action.type) {
		case REQUEST_ACTIVE_MODEL:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_ACTIVE_MODEL:
			// sets new state and fetching ended
			return {
				...state,
				model: {
					...action.payload,
					info: state.model.info && state.model?.info[0]?.modelId === action.payload._id ? state.model.info : [],
					masterClasses: [],
					projectOverview: [],
					qualityGates: [],
					recoMode: false,
				},
				isFetching: false,
			};
		case ACTIVE_MODEL_ERROR:
			// fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		case REQUEST_MODEL_INFO:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_MODEL_INFO:
			// sets new state and fetching ended
			return { ...state, model: { ...state.model, info: action.payload }, isFetching: false };
		case MODEL_INFO_ERROR:
			// fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		case REQUEST_UPDATE_MODEL:
			// only update active model when the active model changes (and not some other)
			if (action.modelId === state.model._id) {
				// keeps state, notifys that fetching started
				return { ...state, isFetching: true, error: null };
			}
			return state;
		case RECEIVE_UPDATE_MODEL:
			// only update active model when the active model changes (and not some other)
			if (action.payload?._id === state.model._id) {
				// sets new state and fetching ended
				return { ...state, model: { ...state.model, ...action.payload }, isFetching: false };
			}
			return state;
		case UPDATE_MODEL_ERROR:
			// only update active model when the active model changes (and not some other)
			if (action.modelId === state.model._id) {
				// fetching ended and error is being set
				return { ...state, error: action.payload, isFetching: false };
			}
			return state;
		case REQUEST_ADD_MODEL:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_ADD_MODEL:
			// sets new state and fetching ended
			return {
				...state,
				model: { masterClasses: [], projectOverview: [], qualityGates: [], ...action.payload },
				isFetching: false,
			};
		case RECEIVE_MODEL_DATA_UPDATE:
			// sets new state and fetching ended
			return { ...state, model: { ...state.model, ...action.payload }, isFetching: false };
		case ADD_MODEL_ERROR:
			// fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		case REQUEST_MASTERCLASS_LIST:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_MASTERCLASS_LIST:
			// sets new state and fetching ended
			return { ...state, model: { ...state.model, masterClasses: action.payload }, isFetching: false };
		case MASTERCLASS_LIST_ERROR:
			// fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		case REQUEST_QUALITY_GATES:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_QUALITY_GATES:
			// sets new state and fetching ended
			return { ...state, model: { ...state.model, qualityGates: action.payload }, isFetching: false };
		case QUALITY_GATES_ERROR:
			// fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		case RECEIVE_DELETE_MODEL:
			return initialActiveModelState;
		case RECEIVE_ADD_VIEW:
			// sets new state and fetching ended
			return {
				...state,
				model: { ...state.model, views: [...state.model.views, action.payload] },
				isFetching: false,
				error: null,
			};
		case RECEIVE_LOGOUT_USER:
			// sets new state and fetching ended
			return { ...initialActiveModelState, isFetching: false };
		case UPDATE_RECO_MODE:
			return { ...state, model: { ...state.model, recoMode: action.payload } };
		default:
			return state;
	}
};
